<template src="./template.html"></template>
<script>
import { mapState } from 'vuex'

import store from 'src/store'
import * as mutationTypes from 'store/mutationTypes'
import ROUTE_NAMES from 'constants/routeNames'
import userService from 'api/user'

export default {
  name: 'chat-app-guest',
  computed: {
    ...mapState({
      date: (state) => state.date.current,
      venue: (state) => state.venue.current,
      user: (state) => state.user.current,
    }),
  },
  data() {
    return {
      saving: false,
      ROUTE_NAMES,
      guestForm: {
        firstName: null,
        lastName: null,
        email: null,
      },
    }
  },
  methods: {
    onMutation(mutation) {
      if (mutation.type === mutationTypes.SHOW_CHAT_APP) {
        // this.scrollCustomerChat();
      }
    },
    updateGuest() {
      this.$validator.validateAll().then((success) => {
        if (success) {
          this.saving = true

          return userService
            .updateMe(this.guestForm)
            .then((data) => {
              this.$store.dispatch('setCurrentUser', data)

              this.saving = false

              this.$router.push({
                name: ROUTE_NAMES.CHAT_APP_HOME,
              })
            })
            .catch((error) => {
              this.saving = false

              this.$store.dispatch('addTopBarNotification', {
                text: error.message,
              })
            })
        }

        return null
      })
    },
  },
  created() {
    this.storeUnsubscribe = store.subscribe(this.onMutation)

    this.loading = true

    const promises = []

    Promise.all(promises)
      .then(() => {
        this.loading = false
      })
      .catch(() => {
        this.loading = false
      })
  },
  destroyed() {
    if (this.storeUnsubscribe) this.storeUnsubscribe()
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Widgets/Chat/ChatAppGuest/index.vue